if (!customElements.get('cs-promotion-badge')) {
  customElements.define('cs-promotion-badge', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      clearTimeout(this.timer);
      this.controller = new AbortController();
      this.update = this.update.bind(this);
      document.addEventListener('visibilitychange', this.update, { signal: this.controller.signal });
      this.update();
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
    }

    update() {
      clearTimeout(this.timer);
      if (!this.isConnected) return;
      const brand = this.querySelector('[data-brand-label]');
      const fallback = this.querySelector('[data-fallback-label]');
      const start = Number(this.dataset.start) * 1000;
      const end = Number(this.dataset.end) * 1000;
      const now = Date.now();
      const valid = Number.isFinite(start) && Number.isFinite(end) && (!start || !end || end > start);
      const active = Boolean(brand && valid && (!start || now >= start) && (!end || now < end));
      if (brand) brand.hidden = !active;
      if (fallback) fallback.hidden = active;
      this.hidden = !active && !fallback;
      const next = [start, end].filter(time => time > now).sort((a, b) => a - b)[0];
      if (brand && valid && next) this.timer = setTimeout(this.update, Math.min(next - now + 30, 2147483647));
    }
  });
}
